import { HiOutlineMail } from 'react-icons/hi'
import { FaWhatsapp } from 'react-icons/fa'
import { TbBrandTelegram } from "react-icons/tb";

const data = [
    { id: 1, icon: <HiOutlineMail />, link: 'mailto:glimarcarolinazuaje@gmail.com' },
    { id: 2, icon: <FaWhatsapp />, link: 'https://wa.me/+584265447014' },
    { id: 3, icon: < TbBrandTelegram />, link: 'https://t.me/gcarolin' }
]

export default data